var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_85",
    "data-name": "Groupe 85",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M19.665,17.665c-.8.8-2.473,2.473-3.622,3.626a1.712,1.712,0,0,1-2.417,0c-1.132-1.132-2.772-2.772-3.622-3.626a6.831,6.831,0,1,1,9.661,0Z",
    transform: "translate(-4.585 -3.439)",
    fill: "none",
    stroke: "#005151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M23.125,18.563A2.563,2.563,0,1,1,20.563,16,2.565,2.565,0,0,1,23.125,18.563Z",
    transform: "translate(-10.313 -9.167)",
    fill: "none",
    stroke: "#005151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M0,0H20.5V20.5H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisation);
export default __webpack_public_path__ + "static/media/localisation.7647600e8ee8354142694c8e29768337.svg";
export { ForwardRef as ReactComponent };